import amplitude from 'amplitude-js';
import settings from '../config/settings';

export const initAmplitude = () => {
  amplitude.getInstance().init(settings.AMPLITUDE_KEY);
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  amplitude.getInstance().logEvent(eventType, eventProperties);
};

export const setAmplitudeUserId = userId => {
  amplitude.getInstance().setUserId(userId);
};
